import React, {useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import {ToolTipPerso} from "../../../components/selects/tooltip_perso";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Radiations simplifiées
// simu id 102

function Simulateur_A1_17(props) {
    const dispatch = useDispatch();

    let currUser = JSON.parse(localStorage.getItem("user"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const [departement, setDepartement] = useState(0)
    const [montant_creance, setMontantCreance] = useState(0)
    const [pouvoir, setMontantPouvoir] = useState(0)
    const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
    const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

    const handleChange = async (setter, value, key) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value, key)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value, key) {
        if (props.isParent) {

            let object = {
                "simulateurid": props.simulateur.id,
                "departementid": departement,
                "inputs": {
                    'montant_creance': parseInt(montant_creance),
                    'montant_pouvoir': parseInt(pouvoir),
                    montant_deb_add: parseInt(montantDeboursAdditionnels),
                    debours_additionnels: parseInt(deboursAdditionnels),
                    convention_honoraires : parseInt(props.conventionHonoraires),
                },
                "pdfInputs": {
                    nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
                    object_convention_honoraires : props.objectConventionHonoraires,
                    montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
                    nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
                    adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
                },
            };
            //For values coming from components
            if (key) {
                if (key === "debours_additionnels") {
                if (value === 0) {
                    setMontantDeboursAdditionnels(0)
                    Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
                }
                Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
                }
                if (key === "montant_deb_add") {
                Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
                }
            }
            //For internal settings
            if (setter === setMontantCreance) {
                Object.assign(object['inputs'], {'montant_creance': parseInt(value)})
            }

            if (setter === setMontantPouvoir) {
                Object.assign(object['inputs'], {'montant_pouvoir': parseInt(value)})
            }

            if (setter === setDepartement) {
                object.departementid = parseInt(value)
            }

            if (setter === props.setConventionHonoraires) {
                if(value === 0){
                props.setNombreConventionHonoraires(1);
                props.setObjectConventionHonoraires(null);
                props.setMontantConventionHonoraires(null);
                props.setNomSignataireConventionHonoraires(null);
                props.setAdresseSignataireConventionHonoraires(null);
                Object.assign(
                    object["inputs"], { convention_honoraires : parseInt(value) },
                    object["pdfInputs"], {
                    nombre_convention_honoraires : null,
                    object_convention_honoraires : null,
                    montant_convention_honoraires : null,
                    nom_signataire_convention_honoraires : null,
                    adresse_signataire_convention_honoraires : null
                    },
                );
                } else {
                Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
                }
            }

            if (setter === props.setNombreConventionHonoraires) {
                Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
            }

            if (setter === props.setObjectConventionHonoraires) {
                Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
            }

            if (setter === props.setMontantConventionHonoraires) {
                Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
            }

            if (setter === props.setNomSignataireConventionHonoraires) {
                Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
            }

            if (setter === props.setAdresseSignataireConventionHonoraires) {
                Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }

    return (
        <div style={styles.container}>
            <div className="cardSimulateur">
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                {props?.isParent === true && props.departements !== "" ?
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                                      handleChange={handleChange} setter={setDepartement}/>
                    </div>
                    :
                    <></>
                }

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Indiquer le montant de la créance inscrite au bordereau (si définitive) ou le montant du bien
                        dégrevé déclaré à l'acte (si partielle) :
                        <ToolTipPerso title={"Principal + accessoires éventuels."}/>
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMontantCreance}
                    />
                </div>

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Indiquer les frais de pouvoir à régler à la banque en Euros :
                        <ToolTipPerso title={"Les frais de pouvoir facturés en sus par un établissement bancaire sont à indiquer."}/>
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMontantPouvoir}
                    />
                </div>

                <DeboursQuestion
                    handleChange={handleChange}
                    deboursAdditionnels={deboursAdditionnels}
                    setDeboursAdditionnels={setDeboursAdditionnels}
                    setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
                />

                <ConventionHonoraires
                    handleChange={handleChange}
                    conventionHonoraires={props.conventionHonoraires}
                    setConventionHonoraires={props.setConventionHonoraires}
                    nombreConventionHonoraires={props.nombreConventionHonoraires}
                    setNombreConventionHonoraires={props.setNombreConventionHonoraires}
                    objectConventionHonoraires={props.objectConventionHonoraires}
                    setObjectConventionHonoraires={props.setObjectConventionHonoraires}
                    montantConventionHonoraires={props.montantConventionHonoraires}
                    setMontantConventionHonoraires={props.setMontantConventionHonoraires}
                    nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
                    setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
                    adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
                    setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
                />
            </div>
        </div>
    )
}

export default Simulateur_A1_17;
